import { useSelector } from 'react-redux';
import * as colors from '../../utils/colors';
import { updateSelector } from '../../wave/selectors/update.selectors';
import {
  selectedSelector,
  waveForIdSelector,
} from '../../wave/selectors/wave.selectors';
import { WaveId } from '../../wave/types/wave.type';
import { getUpdatedWave, isWaveManual } from '../../wave/utils/wave.util';
import { StripSquare } from './StripSquare';
import { exactDurationSelector } from '../../ecg/selectors/ecg.selectors';

interface Props {
  waveId: WaveId;
  height: number;
}

export const WaveBar = ({ waveId, height }: Props) => {
  const baseWave = useSelector(waveForIdSelector(waveId));
  const linkedWave = useSelector(waveForIdSelector(baseWave?.link?.waveId));
  const update = useSelector(updateSelector);
  const selected = useSelector(selectedSelector(waveId));
  const ecgDuration = useSelector(exactDurationSelector);

  if (baseWave == null) {
    return null;
  }

  const isManual = isWaveManual(baseWave);
  const { onset, offset, type } = getUpdatedWave(
    baseWave,
    update,
    ecgDuration,
    linkedWave,
  );
  return (
    <StripSquare
      onset={onset}
      offset={offset}
      main={{
        style: {
          height,
          fill: colors.typeToColor[type],
          fillOpacity: isManual
            ? colors.manualWaveOpacity
            : selected
            ? colors.waveOpacity
            : 0,
        },
      }}
    />
  );
};
